// extracted by mini-css-extract-plugin
module.exports = {"small":"styles_small__wUgPk","smallBold":"styles_smallBold___c_ey"};